<template><div><h1>cookie</h1>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { cookie } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p><code>get *cookie.get(name, [options])*</code></p>
<p>获取 cookie 值。<code>options</code> 参数可选，取值如下：</p>
<ol>
<li><code>converter</code> 转换函数。如果所获取的 cookie 有值，会在返回前传给 <code>converter</code><br>
函数进行转换。</li>
<li>选项对象。对象中可以有两个属性：<code>converter</code> 和 <code>raw</code>. <code>raw</code> 是布尔值，为真时，不会对获取到的<br>
cookie 值进行 URI 解码。</li>
</ol>
<p><strong>注</strong>：如果要获取的 cookie 键值不存在，则返回 <code>undefined</code>.</p>
<p>例子：</p>
<pre class="hljs"><code><span class="hljs-comment">// setup</span>
<span class="hljs-built_in">document</span>.cookie = <span class="hljs-string">'foo=1'</span>
<span class="hljs-built_in">document</span>.cookie = <span class="hljs-string">'bar=2'</span>

cookie.get(<span class="hljs-string">'foo'</span>)
<span class="hljs-comment">// returns '1'</span>

cookie.get(<span class="hljs-string">'bar'</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">s</span>) </span>{ <span class="hljs-keyword">return</span> <span class="hljs-built_in">parseInt</span>(s); } )
<span class="hljs-comment">// returns 2</span>
</code></pre>
<p><code>set *cookie.set(name, value, [options])</code></p>
<p>设置 cookie 值。参数 <code>options</code> 可选，可以有以下属性：<code>path</code>（字符串）、<code>domain</code>（字符串）、<br>
<code>expires</code>（数值或日期对象）、<code>raw</code>（布尔值）。当 <code>raw</code> 为真值时，在设置 cookie 值时，不会进行<br>
URI 编码。</p>
<p>例子：</p>
<pre class="hljs"><code>cookie.set(<span class="hljs-string">'foo'</span>, <span class="hljs-number">3</span>)

cookie.set(<span class="hljs-string">'bar'</span>, <span class="hljs-number">4</span>, {
  <span class="hljs-attr">domain</span>: <span class="hljs-string">'example.com'</span>,
  <span class="hljs-attr">path</span>: <span class="hljs-string">'/'</span>,
  <span class="hljs-attr">expires</span>: <span class="hljs-number">30</span>
})
</code></pre>
<p><code>remove *cookie.remove(name, [options])</code></p>
<p>移除指定的 cookie.</p>
<p>例子：</p>
<pre class="hljs"><code>cookie.remove(<span class="hljs-string">'foo'</span>)

cookie.remove(<span class="hljs-string">'bar'</span>, {
  <span class="hljs-attr">domain</span>: <span class="hljs-string">'example.com'</span>,
  <span class="hljs-attr">path</span>: <span class="hljs-string">'/'</span>
})
</code></pre>
</div></template><script>
export default {
  head: {"title":"cookie | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// cookie-304.vue?01e8e860